module.exports = __webpack_public_path__ + "static/media/Gallery-4.e82cf231.jpg";